import { render, staticRenderFns } from "./tyokertymalaskuri-modal.vue?vue&type=template&id=e513adfc&scoped=true&"
import script from "./tyokertymalaskuri-modal.vue?vue&type=script&lang=ts&"
export * from "./tyokertymalaskuri-modal.vue?vue&type=script&lang=ts&"
import style0 from "./tyokertymalaskuri-modal.vue?vue&type=style&index=0&id=e513adfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e513adfc",
  null
  
)

export default component.exports